 <template>
  <div class="occurring-row">
    <div class="occurring-row__info">
      <p class="occurring-row__info-text">{{rowName}}</p>
      <p class="occurring-row__info-text text-right">{{formattedCount}} ({{percent}}%)</p>
    </div>

    <div ref="rowGraph" class="occurring-row__graph">
      <bar-graph
          v-if="formattedData && graphWidth"
          :barSelectorData="['amount']"
          :graphData="formattedData"
          :margin="margin"
          :radius="0"
          :toolTipContent="toolTipContent"
          :wrapperHeight="graphHeight"
          :wrapperWidth="graphWidth"
          :xPadding="0.65"
          xSelector="date_time"
          centerBars
          hideXticks
          @setToolTipContent="setToolTipContent">
      </bar-graph>
    </div>
  </div>
</template>

<script>
  import BarGraph from '../Graphs/BarGraph'
  import GraphData from '../../mixins/GraphDataMixin'
  import ToolTipContentMixin from '../../mixins/ToolTipContentMixin'
  import { shortenNumber } from '../../utilities'

  export default {
    props: {
      count: [Number, String],
      graphData: Array,
      percent: [Number, String],
      rowData: Object,
      rowName: String,
      useCurrency: Boolean,
    },

    name: 'MostOccurringRow',

    components: {
      BarGraph,
    },

    mixins: [GraphData, ToolTipContentMixin],

    data() {
      return {
        data: null,
        errorMessage: null,
        graphHeight: null,
        graphWidth: null,
        margin: 5,
        showDataTypeList: false,
        toolTipContent: null,
        formattedGraphData: null,
      }
    },

    computed: {
      formattedCount: function() {
        return shortenNumber(this.count, this.useCurrency)
      },

      formattedData: function() {
        if (this.graphData) {
          return this.formattedGraphData = this.buildGraphData(this.graphData)
        } else {
          return this.formattedGraphData = []
        }
      },
    },

    methods: {
      setWrapperWidths() {
        this.graphWidth = this.$refs.rowGraph.offsetWidth
        this.graphHeight = this.$refs.rowGraph.offsetHeight - (this.margin * 2)
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'occurring')
      },
    },

    created() {
    },
  }
</script>